import { MarketingTable } from '../components/marketing/MarketingTable'

export default function AdminMarketingPage({ onEdit, onDelete, onMessage }) {
  return (
    <div className="flex flex-col gap-6">
      <MarketingTable
        onEdit={onEdit}
        onDelete={onDelete}
        onMessage={onMessage}
      />
    </div>
  )
}
